import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import { toastr } from 'react-redux-toastr'
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import { i18n } from '../../translate/i18n';
import { fetchPlacesLeafsService, fetchPlacesRootsService } from '../../services/places';

export const fetchPlacesSuccess = (places) => {
  return {
    type: actionTypes.FETCH_PLACES_SUCCESS,
    places: places
  };
};

export const fetchPlacesByIdSuccess = (place) => {
  return {
    type: actionTypes.FETCH_PLACES_BY_ID_SUCCESS,
    place: place
  };
};

export const fetchPlacesLeafsSuccess = (placesLeafs) => {
  return {
    type: actionTypes.FETCH_PLACES_LEAFS_SUCCESS,
    placesLeafs: placesLeafs
  };
};

export const fetchPlacesRootsSuccess = (placesRoots) => {
  return {
    type: actionTypes.FETCH_PLACES_ROOTS_SUCCESS,
    placesRoots: placesRoots
  };
};

export const requestPlacesFail = (error) => {
  return {
    type: actionTypes.REQUEST_PLACES_FAIL,
    error: error
  };
};

export const requestPlacesStart = () => {
  return {
    type: actionTypes.REQUEST_PLACES_START
  };
};

export const deletePlacesSuccess = (place) => {
  return {
    type: actionTypes.DELETE_PLACES_SUCCESS,
    place: place
  }
}

export const checkDeletePlacesSuccess = (checkDelete) => {
  return {
    type: actionTypes.CHECK_DELETE_PLACES_SUCCESS,
    checkDelete: checkDelete
  }
}

export const updatePlacesSuccess = (place) => {
  return {
    type: actionTypes.UPDATE_PLACES_SUCCESS,
    place: place
  }
}

export const postPlacesSuccess = (place) => {
  return {
    type: actionTypes.POST_PLACES_SUCCESS,
    place: place
  }
}


export const tooglePlaces = (node) => {
  return {
    type: actionTypes.TOOGLE_PLACES,
    node: node
  }
};

export const searchTextPlaces = (str) => {
  return {
    type: actionTypes.SEARCH_TEXT_PLACES,
    searchText: str,
  }
};

export const searchPlaces = () => {
  return {
    type: actionTypes.SEARCH_PLACES,
  }
};

export const setMapConfig = (config) => {
  return {
    type: actionTypes.SET_MAP_CONFIG,
    config: config,
  };
};

export const setCopyPlace = (place) => {

  toastr.info(`${place.type === 'branch' ? i18n.t('setCopyPlace.true') : i18n.t('setCopyPlace.false') } ${i18n.t('setCopyPlace.text')}`, `${place.name} ${i18n.t('setCopyPlace.text')}`)
  return {
    type: actionTypes.SET_COPY_PLACE,
    place
  }
};

export const clearCopyPlace = (place) => {

  return {
    type: actionTypes.CLEAR_COPY_PLACE,
  }
};

export const copyPasteSuccess = (places) => {
  return {
    type: actionTypes.COPY_PASTE_PLACE_SUCCESS,
    places: places
  };
};

export const copyPasteRequest = (copyPlace, pastePlace, siteCopyPart, sites) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    const query = `?${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
    API.post('/places/copypaste/' + copyPlace + '/' + pastePlace + '/' + siteCopyPart + query)
      .then(res => {
        dispatch(copyPasteSuccess(res.data));
        dispatch(clearCopyPlace());
        toastr.success(i18n.t('copyPasteRequestStr.toastr'), i18n.t('copyPasteRequestStr.toastr1'))
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
        toastr.error('Erro', err.response.data.message)
      });
  };
}

export const fetchPlacesById = (id) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    API.get('/places/' + id)
      .then(res => {
        dispatch(fetchPlacesByIdSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};

export const fetchPlaces = (sites) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    const query = `?${sites && sites.length > 0 ? 'sites=' + siteObjectToQuery(sites) : ''}`
    API.get('/places' + query)
      .then(res => {
        dispatch(fetchPlacesSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};

export const fetchPlacesLeafs = (sites) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    fetchPlacesLeafsService(sites)
      .then(res => {
        dispatch(fetchPlacesLeafsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};

export const fetchPlacesRoots = (sites) => {
  return dispatch => {
    dispatch(requestPlacesStart());
    fetchPlacesRootsService(sites)
      .then(res => {
        dispatch(fetchPlacesRootsSuccess(res.data));
      })
      .catch(err => {
        dispatch(requestPlacesFail(err));
      });
  };
};

export const deletePlaces = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestPlacesStart());
      API.put('/places/' + index + '/delete')
        .then(res => {
          dispatch(deletePlacesSuccess(res.data));
          toastr.success(i18n.t('deletePlacesStr.toastr'), `${res.data.name} ${i18n.t('deletePlacesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestPlacesFail(err));
          toastr.error('Erro', err.response.data.message)
          resolve('error');
        });
    })

  }
}

export const checkDeletePlaces = (index) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestPlacesStart());
      API.get('/places/' + index + '/checkdelete')
        .then(res => {
          dispatch(checkDeletePlacesSuccess(res.data));
          resolve(res.data);
        })
        .catch(err => {
          dispatch(requestPlacesFail(err));
          resolve('error');
        });
    })
  }
}

export const postPlaces = (body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(requestPlacesStart());
      API.post('/places', body)
        .then(res => {
          dispatch(postPlacesSuccess(res.data));
          toastr.success(i18n.t('postPlacesStr.toastr'), `${res.data.name} ${i18n.t('postPlacesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestPlacesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('postPlacesStr.toastrError'), i18n.t('postPlacesStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })

  }
}

export const updatePlaces = (index, body) => {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(requestPlacesStart());
      API.put('/places/' + index, body)
        .then(res => {
          dispatch(updatePlacesSuccess(res.data));
          toastr.success(i18n.t('updatePlacesStr.toastr'), `${res.data.name} ${i18n.t('updatePlacesStr.toastr1')}`)
          resolve('success');
        })
        .catch(err => {
          dispatch(requestPlacesFail(err));
          if (err.response.data.message === "Already in use") {
            toastr.error(i18n.t('updatePlacesStr.toastrError'), i18n.t('updatePlacesStr.toastrError1'))
          } else {
            toastr.error('Erro', err.response.data.message)
          }
          resolve('error');
        });
    })
  }
}

